import { render, staticRenderFns } from "./ConfirmationOrder.vue?vue&type=template&id=3ed45574&scoped=true&"
import script from "./ConfirmationOrder.vue?vue&type=script&lang=js&"
export * from "./ConfirmationOrder.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationOrder.vue?vue&type=style&index=0&id=3ed45574&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed45574",
  null
  
)

export default component.exports